<template>
  <v-container fluid class="px-4 px-md-8">
    <p class="headline font-weight-bold my-4">Mi perfil</p>
    <v-card class="mx-auto pt-6 pt-sm-12 transparent" max-width="600" flat>
      <p class="title"></p>
      <v-text-field
        outlined
        :disabled="loading"
        v-model="nombre"
        :label="this.$t('nombre')"
        required
      ></v-text-field>
      <v-text-field outlined v-model="tlf" disabled :label="this.$t('teléfono')"></v-text-field>
      <v-text-field
        outlined
        :disabled="loading"
        v-model="email"
        :append-icon="!verificado ? 'mdi-close' : 'mdi-check'"
        :append-outer-icon="!verificado ? 'mdi-email' : ''"
        :label="this.$t('email')"
        :messages="msjConfirmarEmail"
        @click:append-outer="enviarEmail"
      ></v-text-field>
      <v-btn
        block
        x-large
        class="my-8"
        color="primary"
        :loading="loading"
        @click="guardar"
      >{{this.$t('guardar')}}</v-btn>
    </v-card>
  </v-container>
</template>

<!--<template>
  <v-container fluid class="px-8 px-md-4">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <v-card color="transparent" class="elevation-0">
          <h1 class="px-3 mb-3">Mi perfil</h1>
          <v-card-text>
            <v-text-field :disabled="loading" v-model="nombre" :label="this.$t('nombre')" required></v-text-field>
            <v-text-field v-model="tlf" disabled :label="this.$t('telefono')"></v-text-field>

            <v-text-field
              :disabled="loading"
              v-model="email"
              :prepend-inner-icon="!verificado ? 'mdi-close' : 'mdi-check'"
              :append-outer-icon="!verificado ? 'mdi-email' : ''"
              :label="this.$t('email')"
              :messages="msjConfirmarEmail"
              @click:append-outer="enviarEmail"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="px-3 pt-0 pb-3">
            <v-spacer class="d-none d-sm-block"></v-spacer>
            <v-btn :block="isMobile" color="primary" :loading="loading" @click="guardar">
              <v-icon left dark>mdi-check</v-icon>
              {{this.$t('guardar')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>-->

<script>
import { mapState } from "vuex";
export default {
  //pageTitle: 'Perfil',
  data() {
    return {
      loading: false,
      v: true,
      nombre: "",
      email: "",
      tlf: "",
      verificado: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isMobile: state => state.app.isMobile
    }),
    msjConfirmarEmail() {
      return this.verificado
        ? "Email verificado"
        : "Por favor, verifica tu email";
    }
  },
  methods: {
    guardar() {
      let _vm = this;
      this.loading = true;
      this.$store
        .dispatch("auth/savePerfil", {
          displayName: this.nombre,
          email: this.email
        })
        .then(function(r) {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Perfil actualizado"
          });
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el perfil: " + e
          });
        })
        .finally(function() {
          _vm.loading = false;
        });
    },
    enviarEmail() {
      let _vm = this;
      this.$store
        .dispatch("auth/sendEmail")
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Email enviado. Revisa tu correo"
          });
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar el perfil: " + e
          });
        });
    }
  },
  mounted() {
    this.nombre = this.user.displayName;
    this.email = this.user.email ? this.user.email : "";
    this.tlf = this.user.phoneNumber ? this.user.phoneNumber : "";
    this.verificado = this.user.emailVerified;
  }
};
</script>